import React, { FC } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import ToolsGeneralContent from '@v2/pages/machines/modules/now/components/Tools/components/ToolsGeneralContent';
import { connect } from 'react-redux';
import { PANEL_VIEW_MODE_WIDTH, SCREEN_PADDING_HORIZONTAL_FOR_ITEM } from '@v2/pages/common/constants/base.constants';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import { updateHeaderConfig } from '@reducers/details';
import { getProductionBatchByPart, operationsSearch } from '@reducers/search';
import { usePartDetails } from '@v2/pages/common/hooks/usePartDetails';
import { getPartByID } from '@reducers/parts';
import { getNCFileByPartId } from '@reducers/manufacture';
import { View } from 'react-native';
import { scale } from '@components/frame';
import { isWeb } from '@helpers';

interface PartDetailsToolsProps {}

const PartDetailsToolsComponent: FC<PartDetailsToolsProps> = ({
  clearTools,
  getTools,
  getProductionBatchByPart,
  updateHeaderConfig,
  getPartByID,
  getNCFileByPartId,
  operationsSearch,
}) => {
  const title = useTitle();

  const { refetchTools } = usePartDetails({
    clearTools,
    getTools,
    getProductionBatchByPart,
    updateHeaderConfig,
    getPartByID,
    getNCFileByPartId,
    operationsSearch,
  });

  return (
    <DetailsPageWrapper title={title.tool}>
      <View style={{ flex: 1, paddingHorizontal: scale(SCREEN_PADDING_HORIZONTAL_FOR_ITEM) }}>
        <ToolsGeneralContent
          maxDetailsWidth={PANEL_VIEW_MODE_WIDTH}
          bg={!isWeb ? 'Background/Light/Field on Panel' : 'Background/Light/Field'}
          refetchTools={refetchTools}
        />
      </View>
    </DetailsPageWrapper>
  );
};

const PartDetailsTools = connect(({}) => ({}), {
  clearTools,
  getTools,
  getProductionBatchByPart,
  updateHeaderConfig,
  getPartByID,
  getNCFileByPartId,
  operationsSearch,
})(PartDetailsToolsComponent);

export { PartDetailsTools };
